export const CONTACTS_PATH = '/contacts'
